class Popup extends EventHandler {

  constructor(parentWindow, app) {
    super();
    this._parentWindow = parentWindow;
    this._parentApp    = app;

    this._popupWindow  = null;
    this._popupApp     = null;

    this._popupCreator = false;
  }

  get window() {
    return this._popupWindow;
  }

  get app() {
    return this._popupApp;
  }

  isSupported() {
    const whitelist = [
      /^Windows/,
      /^OS X/,
      /^Ubuntu/,
      /^Debian/,
      /^Fedora/,
      /^Red Hat/,
      /^SuSE/
    ];
    const blacklist = [
      /^Windows Phone/,
      /^Android/,
      /^iOS/
    ];

    let whitelisted = false;
    let blacklisted = false;

    whitelist.forEach(regex => {
      if (Platform.os.family.match(regex)) {
        whitelisted = true;
      }
    });
    blacklist.forEach(regex => {
      if (Platform.os.family.match(regex)) {
        blacklisted = true;
      }
    });

    return whitelisted && !blacklisted;
  }

  async open(options) {
    this._popupWindow = this._parentWindow.open('', 'asktech-widget-popup', "width=370,height=650");
    this._parentWindow.wiin = this._popupWindow;
    if (!this._popupWindow.asktechWidgetPopup) {
      this._popupWindow.asktechWidgetPopup = true;
      this._popupCreator = true;
    }
    else {
      this._popupWindow.focus();
    }
    await this._attachPopupEvents();
    await this._popupApp.show(options);
  }

  close() {
    this.destroy();
  }

  _attachPopupEvents() {
    if (!this._popupWindow) throw "Popup does not exist";
    return new Promise((resolve) => {
      if (this._popupCreator) {
        if (document.readyState == "complete") {
          this._injectWidget().then(resolve);
        }
        else {
          this._popupWindow.addEventListener('load', event => {
            this._injectWidget().then(resolve);
          });
        }
      }
      else {
        this._popupApp = this._popupWindow['_' + this._parentApp._brand];
        this._popupApp.on('close', () => {
          this.destroy();
        });
        resolve();
      }
    });
  }

  _injectWidget() {
    return new Promise(resolve => {
      const popup = this;
      const popupWindow = this._popupWindow;
      const settingsObjectName = '_' + this._parentApp._brand + 'Settings';

      this._popupWindow[settingsObjectName] = Object.assign({
        onInit: async app => {
          this._popupApp = app;
          app.on('close', () => {
            this.destroy();
          });
          await app.show();
          this._popupWindow.document.body.style.display = "";
          resolve();
        }
      }, this._parentWindow[settingsObjectName]);

      this._popupWindow.document.head.insertAdjacentHTML('beforeend', `
        <style>
          #slaask-button {
            display: none;
          }
        </style>
        `);

      this._popupWindow.document.body.style.display = "none";

      const script = this._popupWindow.document.createElement("script");
      script.src = this._parentApp._cdn_url + '/chat_loader.js';
      this._popupWindow.document.body.appendChild(script);
    });
  }

  destroy() {
    this._trigger('destroy');
    if (this._popupWindow) {
      this._popupWindow.close();
    }
  }

}
